import { API as e, Resource as t } from "@coveo/platform-client";
// src/resources/OrganizationCustomerKeysResource.ts
var n = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}/customerkeys`;
	}
	rotate(e) {
		return this.api.put(this.buildPath(`${n.baseUrl}/${e}/rotate`));
	}
	deactivate(e) {
		return this.api.put(this.buildPath(`${n.baseUrl}/${e}/deactivate`));
	}
	activate(e) {
		return this.api.put(this.buildPath(`${n.baseUrl}/${e}/activate`));
	}
	list() {
		return this.api.get(this.buildPath(`${n.baseUrl}`));
	}
	create(e) {
		return this.api.post(this.buildPath(`${n.baseUrl}`), e);
	}
	get(e) {
		return this.api.get(this.buildPath(`${n.baseUrl}/${e}`));
	}
	delete(e) {
		return this.api.delete(this.buildPath(`${n.baseUrl}/${e}`));
	}
	inUse() {
		return this.api.get(this.buildPath(`${n.baseUrl}/in-use`));
	}
	valid() {
		return this.api.get(this.buildPath(`${n.baseUrl}/valid`));
	}
};
export { n as OrganizationCustomerKeysResource };

//# sourceMappingURL=OrganizationCustomerKeysResource.js.map